import type {
  BoardAutomationOnCompleteDraft,
  BoardAutomationOnMoveDraft,
  TaskTrackerAutomationColumnOption,
  TaskTrackerBoardAutomation,
} from '../domain.types'
import {
  createEmptyBoardAutomationOnCompleteDraft,
  createEmptyBoardAutomationOnMoveDraft,
} from '../../lib/taskTrackerBoardAutomations.utils'

export type BoardAutomationsBoardState = {
  loading: boolean
  saving: boolean
  error: string | null
  availableColumns: TaskTrackerAutomationColumnOption[]
  onCompleteDraft: BoardAutomationOnCompleteDraft
  onMoveDraft: BoardAutomationOnMoveDraft
  savedOnCompleteDraft: BoardAutomationOnCompleteDraft
  savedOnMoveDraft: BoardAutomationOnMoveDraft
  completeAutomation: TaskTrackerBoardAutomation | undefined
  moveAutomation: TaskTrackerBoardAutomation | undefined
}

export type BoardAutomationsSliceState = {
  byBoardId: Record<number, BoardAutomationsBoardState>
}

export const createEmptyBoardAutomationsBoardState =
  (): BoardAutomationsBoardState => ({
    loading: false,
    saving: false,
    error: null,
    availableColumns: [],
    onCompleteDraft: createEmptyBoardAutomationOnCompleteDraft(),
    onMoveDraft: createEmptyBoardAutomationOnMoveDraft(),
    savedOnCompleteDraft: createEmptyBoardAutomationOnCompleteDraft(),
    savedOnMoveDraft: createEmptyBoardAutomationOnMoveDraft(),
    completeAutomation: undefined,
    moveAutomation: undefined,
  })

export const createInitialBoardAutomationsState =
  (): BoardAutomationsSliceState => ({
    byBoardId: {},
  })
